import { render } from "./Bpmn.vue?vue&type=template&id=10cbe2ea&scoped=true"
import script from "./Bpmn.vue?vue&type=script&lang=js"
export * from "./Bpmn.vue?vue&type=script&lang=js"

import "./Bpmn.vue?vue&type=style&index=0&id=10cbe2ea&scoped=true&lang=css"
import "./Bpmn.vue?vue&type=style&index=1&id=10cbe2ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cbe2ea"]])

export default __exports__